import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from '@statsbomb/kitbag-components';
import { LoaderInlineWrapper, LoaderInlineLabel } from './LoaderInline.styles';

const LoaderInline = ({ text, fadeIn }) => (
  <LoaderInlineWrapper fadeIn={fadeIn}>
    <Loader size="0.75rem" />
    {text && <LoaderInlineLabel>{text}</LoaderInlineLabel>}
  </LoaderInlineWrapper>
);

LoaderInline.propTypes = {
  text: PropTypes.string,
  fadeIn: PropTypes.bool,
};

LoaderInline.defaultProps = {
  text: '',
  fadeIn: false,
};

export default LoaderInline;
